import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  affiliateName: string;
  isBot: boolean;
};

class AffiliateLinkClickEvent extends UserEvent<EventData> {
  private getAffiliateName() {
    return this.data.affiliateName;
  }

  sendToGtm() {
    gtm.pushToDataLayer({
      event: 'retailerLinkClick',
      retailer_name: this.getAffiliateName()
    });
  }
}

export default AffiliateLinkClickEvent;
